import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-xl text-background-50"></i>
            </div>
            <span className="font-heading text-xl text-foreground-900">
              虫虫漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/hot"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-48 pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50 py-3 px-4">
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/category/hot" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer">分类浏览</Link>
              <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap cursor-pointer">关于我们</Link>
              <div className="relative mt-1">
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="w-full pl-9 pr-4 py-2 text-sm rounded-full bg-background-100 border border-background-200/70 text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-all"
                />
                <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}